/* eslint-disable no-unused-vars */
import { ChooseBase, ModalFooter, Loader } from 'components';
import * as S from './ExistingAudience.styled';
import Content from './Content';
import { useFacade } from './useFacade';

const ExistingAudience = ({ handleCloseWindow }) => {
  const {
    search,
    isChanged,
    handleSearchOnChange,
    handleClearSearchValue,
    isSuccess,
    selectedAud,
    setSelectedAud,
    saveButtonAction,
    faundedAudience,
  } = useFacade(handleCloseWindow);

  return (
    <>
      <S.Content>
        <ChooseBase.OneSection
          title='Search by name'
          dontShowHeader
          searchValue={search}
          searchOnChange={handleSearchOnChange}
          handleClearSearchValue={handleClearSearchValue}
        >
          {isSuccess ? (
            <Content
              search={search}
              isChanged={isChanged}
              data={faundedAudience}
              selectedAud={selectedAud}
              setSelectedAud={setSelectedAud}
            />
          ) : (
            <Loader.Local delay={100} />
          )}
        </ChooseBase.OneSection>
      </S.Content>
      <ModalFooter
        saveButtonText='Use this Audience'
        saveButtonOnClick={saveButtonAction}
        close={handleCloseWindow}
        saveButtonDisabled={isChanged.current}
      />
    </>
  );
};

export default ExistingAudience;
